<template>
  <div>
    <el-row :gutter="10">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="Transacciones por mes" name="monthly">
          <el-row :gutter="10">
            <el-col :span="3">
              <el-select
                v-model="value"
                size="small"
                placeholder="Select"
                @change="getNavitionTransactionReport"
              >
                <el-option
                  v-for="item in years"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select
                v-model="companyFilter"
                class="box-item"
                size="small"
                @change="handleCompanyChange"
              >
                <el-option
                  v-for="company in companyList"
                  :key="company.value"
                  :label="company.label"
                  :value="company.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select
                placeholder="Tipo de Documento"
                v-model="DocumentType"
                size="small"
                @change="handleDocumentTypeChange"
              >
                <el-option
                  v-for="type in DocumentTypeList"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <rabbey-table-3
              show-summary
              sum-text="Total"
              :loading="mainTableLoading"
              :data="transactionUsers"
              :columns="transactionColumns"
            />
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Transacciones por día" name="daily">
          <el-row :gutter="10">
            <el-col :span="3">
              <el-select
                v-model="value"
                size="small"
                placeholder="Select"
                @change="getNavitionTransactionReport"
              >
                <el-option
                  v-for="item in years"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <MonthsComponent
                :size="'small'"
                :initial="month"
                @change="handleMonthChange"
              />
            </el-col>
            <el-col :span="3">
              <el-select
                v-model="companyFilter"
                class="box-item"
                size="small"
                @change="handleCompanyChange"
              >
                <el-option
                  v-for="company in companyList"
                  :key="company.value"
                  :label="company.label"
                  :value="company.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-select
                placeholder="Tipo de Documento"
                v-model="DocumentType"
                size="small"
                @change="handleDocumentTypeChange"
              >
                <el-option
                  v-for="type in DocumentTypeList"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <rabbey-table-3
              show-summary
              sum-text="Total"
              :loading="mainTableLoading"
              :data="daylyTransactionUsers"
              :columns="daylyTransactionColumns"
            />
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>

    <el-drawer
      title="Detalle de Transacciones de Navition"
      :visible="openDetail"
      :before-close="CloseTransactionDetail"
      size="60%"
    >
      <el-row style="margin-top: 20px">
        <el-form label-position="top">
          <el-col :span="11" style="margin-left: 20px">
            <el-form-item label="Agente de Cobro">
              <el-input
                v-model="transactionDeatail.PersonName"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item label="Mes">
              <el-input
                v-model="transactionDeatail.Month"
                disabled
                style="width: 300px"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div v-show="activeName === 'monthly'">
        <DetailChart ref="detailChart" :DetailParams="DetailData" />
      </div>

      <h2 style="margin-left: 20px">Listado de Transacciones</h2>

      <rabbey-table-3
        :loading="detailTableLoading"
        :data="transactionDeatail.TransactionList"
        :columns="transactionDetailColumns"
        style="margin: 20px"
      />
    </el-drawer>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
<script>
// import ImagePerson from "@/components/functionals/ImagePerson.vue";
import CashFlowHyperlink from "@/components/functionals/CashFlowHyperlink.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import { formatDate } from "@/utils";
import DetailChart from "@/views/Charts/NavitionTransactionChart.vue";
import MonthsComponent from "@/components/Global_System/MonthsComponent";

const actualMonth = new Date().getMonth() + 1;

export default {
  components: { RabbeyTable3 },
  name: "NavitionTransactions",
  components: {
    DetailChart,
    MonthsComponent
  },
  data() {
    return {
      activeName: "monthly",
      companyFilter: "TB",
      companyList: [
        {
          label: "Todas",
          value: "TD"
        },
        {
          label: "Tennos Business",
          value: "TB"
        },
        {
          label: "Rabbey",
          value: "RB"
        },
        {
          label: "Magytrack",
          value: "MTR"
        },
        {
          label: "Ventafiel",
          value: "VF"
        }
      ],
      mainTableLoading: false,
      detailTableLoading: false,
      openDetail: false,
      years: [],
      value: this.year,
      month: actualMonth,
      DocumentType: "",
      DocumentTypeList: [
        {
          label: "Todos",
          value: 0
        },
        {
          label: "Pago",
          value: 1
        },
        {
          label: "Factura",
          value: 2
        },
        {
          label: "Nota Crédito",
          value: 3
        },
        {
          label: "Docs. interés",
          value: 4
        },
        {
          label: "Recordatorio",
          value: 5
        },
        {
          label: "Reembolso",
          value: 6
        }
      ],
      transactionUsers: [],
      transactionDeatail: {
        PersonName: "",
        Month: "",
        TransactionList: []
      },
      transactionColumns: [
        {
          prop: "UserName",
          label: "Usuario de Navition",
          width: 300,
          sortable: true
          // formatter: ImagePerson,
          // attrs: {
          //   imgKey: "SalesPersonPhoto"
          // }
        },
        {
          prop: "Enero",
          label: "Enero",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Febrero",
          label: "Febrero",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Marzo",
          label: "Marzo",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Abril",
          label: "Abril",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Mayo",
          label: "Mayo",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Junio",
          label: "Junio",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Julio",
          label: "Julio",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Agosto",
          label: "Agosto",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Septiembre",
          label: "Septiembre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Octubre",
          label: "Octubre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Noviembre",
          label: "Noviembre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Diciembre",
          label: "Diciembre",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        }
        // {
        //   prop: "Total",
        //   label: "Total"
        // }
      ],
      transactionDetailColumns: [
        {
          prop: "EntryNo",
          label: "No. Transacción",
          width: 150
        },
        {
          prop: "UserName",
          label: "Usuario Navition",
          width: 250
        },
        {
          prop: "PostingDate",
          label: "Fecha Transacción",
          formatter: (row) => formatDate(row.PostingDate, "DD/MM/yyyy"),
          width: 150
        },
        {
          prop: "Description",
          label: "Descripción"
        }
      ],
      DetailChartX: ["1", "2", "3", "4", "5", "6", "7", "8"],
      DetailChartY: [5, 20, 36, 10, 10, 20, 40, 15],
      DetailData: {
        Year: 0,
        Month: 0,
        CompanyId: "",
        UserName: "",
        DocumentType: 0
      },
      daylyTransactionUsers: [],
      daylyTransactionColumns: [
        {
          prop: "UserName",
          label: "Usuario de Navition",
          width: 300,
          sortable: true,
          fixed: "left"
          // formatter: ImagePerson,
          // attrs: {
          //   imgKey: "SalesPersonPhoto"
          // }
        },
        {
          prop: "First",
          label: "1",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Second",
          label: "2",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Third",
          label: "3",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Fourth",
          label: "4",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Fifth",
          label: "5",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Sixth",
          label: "6",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Seventh",
          label: "7",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Eighth",
          label: "8",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Ninth",
          label: "9",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Tenth",
          label: "10",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Eleventh",
          label: "11",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Twelfth",
          label: "12",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Thirteenth",
          label: "13",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Fourteenth",
          label: "14",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Fifteenth",
          label: "15",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Sixteenth",
          label: "16",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Seventeenth",
          label: "17",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Eighteenth",
          label: "18",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Nineteenth",
          label: "19",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Twentieth",
          label: "20",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentyFirst",
          label: "21",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentySecond",
          label: "22",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentyThird",
          label: "23",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentyFourth",
          label: "24",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentyFifth",
          label: "25",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentySixth",
          label: "26",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentySeventh",
          label: "27",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentyEighth",
          label: "28",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "TwentyNinth",
          label: "29",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "Thirtieth",
          label: "30",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        },
        {
          prop: "ThirtyFirst",
          label: "31",
          formatter: CashFlowHyperlink,
          attrs: {
            openDrawer: this.OpenTransactionDetail
          }
        }
      ],
      OrdinalMonthsNumbers: {
        First: 1,
        Second: 2,
        Third: 3,
        Fourth: 4,
        Fifth: 5,
        Sixth: 6,
        Seventh: 7,
        Eighth: 8,
        Ninth: 9,
        Tenth: 10,
        Eleventh: 11,
        Twelfth: 12,
        Thirteenth: 13,
        Fourteenth: 14,
        Fifteenth: 15,
        Sixteenth: 16,
        Seventeenth: 17,
        Eighteenth: 18,
        Nineteenth: 19,
        Twentieth: 20,
        TwentyFirst: 21,
        TwentySecond: 22,
        TwentyThird: 23,
        TwentyFourth: 24,
        TwentyFifth: 25,
        TwentySixth: 26,
        TwentySeventh: 27,
        TwentyEighth: 28,
        TwentyNinth: 29,
        Thirtieth: 30,
        ThirtyFirst: 31
      }
    };
  },
  beforeCreate() {
    var fecha = new Date();
    this.year = fecha.getFullYear();
  },
  created() {
    switch (this.activeName) {
      case "monthly":
        this.getNavitionTransactionReport();
        break;
      case "daily":
        this.getNavitionDaylyTransactionReport();
        break;
    }
    this.yearCalculator();
  },
  methods: {
    getNavitionTransactionReport() {
      this.mainTableLoading = true;
      this.$http
        .get("/api/accountsReceivable/NavitionTransactionReport", {
          params: {
            Year: this.value,
            CompanyId: this.companyFilter,
            DocumentType: this.DocumentType
          }
        })
        .then((resp) => {
          this.transactionUsers = resp.data;
          this.mainTableLoading = false;
        });
    },
    getNavitionDaylyTransactionReport() {
      this.mainTableLoading = true;
      this.$http
        .get("/api/accountsReceivable/NavitionDaylyTransactionReport", {
          params: {
            Year: this.value,
            Month: this.month,
            CompanyId: this.companyFilter,
            DocumentType: this.DocumentType
          }
        })
        .then((resp) => {
          this.daylyTransactionUsers = resp.data;
          this.mainTableLoading = false;
        });
    },
    handleCompanyChange(company) {
      if (company) {
        this.companyFilter = company;
        switch (this.activeName) {
          case "monthly":
            this.getNavitionTransactionReport();
            break;
          case "daily":
            this.getNavitionDaylyTransactionReport();
            break;
        }
      } else {
        this.companyFilter = "TB";
        switch (this.activeName) {
          case "monthly":
            this.getNavitionTransactionReport();
            break;
          case "daily":
            this.getNavitionDaylyTransactionReport();
            break;
        }
      }
    },
    yearCalculator() {
      for (var i = 2018; i <= this.year; i++) {
        this.years.push(i);
      }
    },

    OpenTransactionDetail(row, column) {
      this.detailTableLoading = true;
      this.transactionDeatail.PersonName = row.UserName;
      this.transactionDeatail.Month = column;

      switch (this.activeName) {
        case "monthly":
          this.DetailData = {
            Year: this.value,
            Month: this.getMonthNumber(column),
            CompanyId: this.companyFilter,
            UserName: row.UserName,
            DocumentType: this.DocumentType
          };
          this.$http
            .get("/api/accountsReceivable/NavitionTransactionReportDetail", {
              params: {
                Year: this.DetailData.Year,
                Month: this.DetailData.Month,
                CompanyId: this.companyFilter,
                UserName: this.DetailData.UserName,
                DocumentType: this.DetailData.DocumentType
              }
            })
            .then((resp) => {
              this.transactionDeatail.TransactionList = resp.data;
              this.detailTableLoading = false;
              this.$refs.detailChart.getChartData();
            });
          break;
        case "daily":
          this.DetailData = {
            Year: this.value,
            Month: this.month,
            day: this.OrdinalMonthsNumbers[column],
            CompanyId: this.companyFilter,
            UserName: row.UserName,
            DocumentType: this.DocumentType
          };
          this.$http
            .get("/api/accountsReceivable/NavitionTransactionReportDetail", {
              params: {
                Year: this.DetailData.Year,
                Month: this.DetailData.Month,
                day: this.DetailData.day,
                CompanyId: this.DetailData.CompanyId,
                UserName: this.DetailData.UserName,
                DocumentType: this.DetailData.DocumentType
              }
            })
            .then((resp) => {
              this.transactionDeatail.TransactionList = resp.data;
              this.detailTableLoading = false;
              // this.$refs.detailChart.getChartData();
            });
          break;
      }

      this.openDetail = true;
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.transactionDeatail.TransactionList = [];
      this.$refs.detailChart.bar.series[0].data = [];
      this.$refs.detailChart.loading = true;
    },
    getMonthNumber(month) {
      switch (month) {
        case "Enero":
          return 1;
        case "Febrero":
          return 2;
        case "Marzo":
          return 3;
        case "Abril":
          return 4;
        case "Mayo":
          return 5;
        case "Junio":
          return 6;
        case "Julio":
          return 7;
        case "Agosto":
          return 8;
        case "Septiembre":
          return 9;
        case "Octubre":
          return 10;
        case "Noviembre":
          return 11;
        case "Diciembre":
          return 12;
      }
    },
    handleDocumentTypeChange(type) {
      switch (this.activeName) {
        case "monthly":
          this.getNavitionTransactionReport();
          break;
        case "daily":
          this.getNavitionDaylyTransactionReport();
          break;
      }
    },
    handleTabClick(tab) {
      switch (tab.name) {
        case "monthly":
          this.getNavitionTransactionReport();
          break;
        case "daily":
          this.getNavitionDaylyTransactionReport();
          break;
      }
    },
    handleMonthChange(month) {
      this.month = month;
      switch (this.activeName) {
        case "monthly":
          this.getNavitionTransactionReport();
          break;
        case "daily":
          this.getNavitionDaylyTransactionReport();
          break;
      }
    }
  }
};
</script>
